var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2197(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.788,
    height: 24.784,
    viewBox: "0 0 24.788 24.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2197",
    "data-name": "Group 2197",
    transform: "translate(452.242 -133.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4429",
    "data-name": "Path 4429",
    d: "M-452.242,149.893V133.387h24.776c0,.079.011.157.011.235q0,4.978,0,9.957c0,.04,0,.081,0,.121a.525.525,0,0,1-.508.516.508.508,0,0,1-.505-.534q0-2.083,0-4.167c0-1.623,0-3.246,0-4.869,0-.2-.046-.262-.253-.262q-11.132.008-22.264,0c-.2,0-.26.05-.26.255q.008,7,.005,14c0,.07.009.141.015.237h9.7c.378,0,.6.165.622.467a.492.492,0,0,1-.46.545c-.072.006-.145,0-.218,0h-10.661Z",
    transform: "translate(0)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4430",
    "data-name": "Path 4430",
    d: "M-398.26,176.97h-10.328v10.336a2.2,2.2,0,0,0,.252-.044c.888-.264,1.774-.532,2.662-.795.124-.037.2-.086.179-.231a.828.828,0,0,1,0-.193,1.79,1.79,0,0,0-.456-1.512,2.463,2.463,0,0,1-.578-1.776,19.476,19.476,0,0,1,.069-2.174,3,3,0,0,1,2.355-2.5,3.092,3.092,0,0,1,3.212,1.3,3.137,3.137,0,0,1,.552,1.848c-.01.668,0,1.341-.079,2a2.613,2.613,0,0,1-.811,1.535.48.48,0,0,0-.15.384c.008.347.012.695,0,1.042a.228.228,0,0,0,.2.267c.466.126.931.259,1.394.395a.523.523,0,0,1,.427.667.523.523,0,0,1-.711.307q-.942-.266-1.881-.538a.523.523,0,0,1-.44-.579c0-.654,0-1.308,0-1.962a.632.632,0,0,1,.25-.522,2.063,2.063,0,0,0,.787-1.693c-.007-.509.011-1.018-.015-1.526a2.1,2.1,0,0,0-2.112-1.978,2.055,2.055,0,0,0-2.017,2.082,17.211,17.211,0,0,0,.051,1.981,1.992,1.992,0,0,0,1.841,1.729c.032,0,.063.01.105.017v1.025l-.975-.159c0,.336,0,.673,0,1.009a.506.506,0,0,1-.435.577c-1.086.33-2.168.677-3.263.975a3.211,3.211,0,0,1-1.031.037c-.281-.019-.41-.226-.41-.558q0-2.144,0-4.288,0-3.4,0-6.807c0-.566.136-.705.693-.705h11.023c.506,0,.669.158.669.663q0,3.719,0,7.437a1.291,1.291,0,0,1-.027.288.5.5,0,0,1-.476.378.5.5,0,0,1-.491-.388,1.652,1.652,0,0,1-.026-.337q0-3.343,0-6.686Z",
    transform: "translate(-40.554 -40.498)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4431",
    "data-name": "Path 4431",
    d: "M-190.279,401.5a6.213,6.213,0,0,1-6.186-6.2,6.211,6.211,0,0,1,6.22-6.192,6.21,6.21,0,0,1,6.174,6.213A6.211,6.211,0,0,1-190.279,401.5Zm.019-11.378a5.2,5.2,0,0,0-5.189,5.191,5.2,5.2,0,0,0,5.184,5.172,5.2,5.2,0,0,0,5.178-5.18A5.2,5.2,0,0,0-190.26,390.117Z",
    transform: "translate(-243.384 -243.324)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4432",
    "data-name": "Path 4432",
    d: "M-124.945,250.9v.979h-7.193V250.9Z",
    transform: "translate(-304.594 -111.816)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4433",
    "data-name": "Path 4433",
    d: "M-132.335,294.442v-.978h7.2v.978Z",
    transform: "translate(-304.407 -152.321)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4434",
    "data-name": "Path 4434",
    d: "M-132.319,337.317v-.979h7.195v.979Z",
    transform: "translate(-304.422 -193.117)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4435",
    "data-name": "Path 4435",
    d: "M-130.406,472.558c.077-.074.142-.133.2-.195q1.49-1.489,2.979-2.98a.54.54,0,0,1,.6-.2.5.5,0,0,1,.244.787,1.35,1.35,0,0,1-.131.143q-1.72,1.721-3.442,3.442a.534.534,0,0,1-.891,0q-.7-.7-1.4-1.4a.507.507,0,0,1-.067-.768.521.521,0,0,1,.788.05C-131.155,471.8-130.788,472.173-130.406,472.558Z",
    transform: "translate(-304.286 -319.496)",
    fill: "#4c5b71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2197);
export default __webpack_public_path__ + "static/media/Group 2197.a3e55f6fce4ebe05c1c0d3bdc0ce7b93.svg";
export { ForwardRef as ReactComponent };